import Alpine from "alpinejs";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const imageParallaxAnimation = () => {
  Alpine.data("imageParallaxAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const image = this.$refs.image as HTMLElement | null;
      if (!image) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });

      tl.fromTo(
        image,
        { yPercent: -10 },
        {
          yPercent: 10,
          ease: "none",
        }
      );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.scrollTrigger?.kill();
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
